import React, { useEffect, useState } from 'react';
import { LuHistory, LuShieldCheck, LuChevronRight } from 'react-icons/lu';
import api from '../../services/api';
import { fechaAR, getTodayISO } from '../../utils/dateUtils';
import { Monto } from '../../context/MontosContext';

// Historial de un equipo dentro del buscador de Trabajos (20-oct-2026; antes era un botón del Panel
// que solo mostraba texto). Si lo que se escribió es un N/S, arriba de los resultados aparece la
// línea de tiempo del equipo, con estado y monto, y cada trabajo se abre tocándolo.
const pareceSerie = (q) => /^[a-z0-9-]{4,}$/i.test(q) && /\d/.test(q);
const ESTADO = {
    COMPLETADO: 'Hecho', REALIZADO: 'Hecho', PENDIENTE_FACTURACION: 'A facturar', FACTURADO: 'Facturado', COBRADO: 'Cobrado',
};

export default function HistorialEnBusqueda({ busqueda, onAbrir }) {
    const q = String(busqueda || '').trim();
    const [data, setData] = useState(null);

    useEffect(() => {
        setData(null);
        if (!pareceSerie(q)) return undefined;
        let vivo = true;
        const t = setTimeout(() => {
            api.get('/equipos/historial', { params: { serie: q } })
                .then(r => { if (vivo && r.data?.encontrado) setData(r.data); })
                .catch(() => { /* sin historial: solo los resultados de siempre */ });
        }, 450);
        return () => { vivo = false; clearTimeout(t); };
    }, [q]);

    if (!data) return null;
    const hoy = getTodayISO();
    const garantia = data.visitas?.find(v => v.garantiaHasta)?.garantiaHasta;
    const enGarantia = garantia && String(garantia) >= hoy;
    const eq = data.equipo;

    return (
        <div className="rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] overflow-hidden">
            <div className="p-3.5 space-y-1">
                <p className="flex items-center gap-1.5 text-label font-black uppercase tracking-widest text-muted"><LuHistory size={13} /> Historial del equipo</p>
                <p className="text-body font-black text-ink">{eq.serie}<span className="font-bold text-muted">{[eq.marca, eq.modelo].filter(Boolean).length ? ` · ${[eq.marca, eq.modelo].filter(Boolean).join(' ')}` : ''}</span></p>
                <p className="text-caption text-secondary truncate">{[eq.cliente, eq.sede, eq.ubicacion].filter(Boolean).join(' · ')}</p>
                {garantia && (
                    <p className={`inline-flex items-center gap-1 text-label font-black ${enGarantia ? 'text-[var(--success-tx)]' : 'text-muted'}`}>
                        <LuShieldCheck size={13} /> {enGarantia ? `En garantía hasta ${fechaAR(garantia)}` : `Garantía vencida (${fechaAR(garantia)})`}
                    </p>
                )}
            </div>
            {data.visitas.length === 0 ? (
                <p className="px-3.5 pb-3.5 text-caption text-muted">Sin trabajos hechos todavía.</p>
            ) : (
                <div className="divide-y divide-black/[0.05] dark:divide-white/[0.05] border-t border-black/[0.05] dark:border-white/[0.05]">
                    {data.visitas.map((v, i) => (
                        <button key={`${v.servicioId}-${i}`} type="button" onClick={() => onAbrir(v.servicioId)}
                            className="w-full flex items-center gap-3 px-3.5 py-2.5 text-left active:bg-chip">
                            <div className="flex-1 min-w-0">
                                <p className="text-caption">
                                    <span className="font-black text-ink">{fechaAR(v.fecha)}</span>
                                    <span className="text-muted"> · {ESTADO[v.estado] ? `${ESTADO[v.estado]}${v.archivado ? ' · archivado' : ''}` : v.archivado ? 'Archivado' : v.estado}{v.tecnico ? ` · ${v.tecnico.split(' ')[0]}` : ''}</span>
                                </p>
                                <p className="text-caption text-secondary truncate">{v.trabajo || 'Sin detalle'}</p>
                            </div>
                            {v.monto != null && <Monto valor={Number(v.monto)} className="shrink-0 text-caption font-black text-ink" />}
                            <LuChevronRight size={16} className="shrink-0 text-muted" />
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
